import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Clock } from "lucide-react";
import { lazy } from "react";

const FeuillesDeTempsDashboard = lazy(() =>
  import("@/features/rh/feuilles-de-temps/components/FeuillesDeTempsDashboard").then((m) => ({
    default: m.default,
  })),
);

export const Route = createFileRoute("/_app/rh/feuilles-de-temps/")({
  loader: requirePermission(PERMISSIONS.RH.FEUILLES_DE_TEMPS.VIEW),
  staticData: {
    title: "Feuilles de Temps",
    icon: Clock,
    tab_icon: Clock,
    permission: PERMISSIONS.RH.FEUILLES_DE_TEMPS.VIEW,
    module: "rh",
    section: "Ressources Humaines",
    order: 40,
    showInNav: true,
    showInTab: true,
  },
  component: FeuillesDeTempsDashboard,
});
